// extracted by mini-css-extract-plugin
export default {"resizeDiv":"DataExplorer_resizeDiv__saUNL","resizeBorder":"DataExplorer_resizeBorder__lIuWe"};